import { LivelloConsultabilitaEnum } from "../enum/livello-consultabilita-enum";
import { RepertoriazioneEnum } from "../enum/repertoriazione-enum";

export class ValoriDefaultFascicoloVO {
  oggetto: string;
  datiComuni: boolean;
  datiParticolari: boolean;
  datiGiudiziari: boolean;
  livelloConsultabilita: LivelloConsultabilitaEnum;
  repertoriazione: RepertoriazioneEnum;
}
